import { dataModeEnum } from '../../const';
import { UserDetailState } from './interface';

export const initialState: UserDetailState = {
  userData: {
    data: null,
    lastLocation: null,
    status: null,
  },
  userHistoric: {
    data: null,
    status: null,
  },
  personalData: {
    data: null,
    status: null,
  },
  healthData: {
    data: {
      pathologies: null,
      interventions: null,
      allergies: null,
      medications: null,
      situations: null,
      vaccines: null,
    },
    loading: {},
    status: null,
  },
  personalInfo: {
    data: {
      environmentpets: null,
      environmentservices: null,
      social: null,
      personalcontacts: null,
      generalcontacts: null,
    },
    loading: {},
    status: null,
  },
  healthService: {
    data: null,
    status: null,
  },
  healthInsurance: {
    data: null,
    status: null,
  },
  measures: {
    data: [],
    status: null,
  },
  measuresByDate: {
    data: [],
    status: null,
  },
  measuresByType: {
    data: {},
    status: null,
    requests: {},
  },
  effectiveMeasureRules: {
    data: [],
    status: null,
    patientId: null,
  },
  relatives: {
    data: [],
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  actions: {
    data: [],
    filterableValues: {},
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  notifications: {
    data: [],
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  unreadNotifications: {
    data: [],
    status: null,
  },
  termsAndConditionsAgreement: {
    data: [],
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  historicServiceState: {
    data: [],
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  servicesState: {
    data: [],
    status: null,
  },
  serviceConfiguration: {
    data: [],
    status: null,
    newServiceConfiguration: null,
  },
  serviceContactWay: {
    data: [],
    status: null,
  },
  agendaSelected: null,
  activeAgenda: {
    data: [],
    mode: dataModeEnum.new,
    status: null,
    pagination: {
      page: 0,
      total: 1,
    },
  },
  finishedAgenda: {
    data: [],
    mode: dataModeEnum.new,
    status: null,
    pagination: {
      page: 0,
      total: 1,
    },
  },
  notes: {
    data: [],
    status: null,
    pagination: {
      page: 0,
      total: 0,
    },
  },
  notesAllTypes: {
    data: [],
    pagination: {
      page: 0,
      total: 0,
    },
    status: null,
  },
  videoCall: {
    uri: null,
  },
  report: {
    data: null,
    status: null,
  },
  resolutionSelected: null,
  rules: {
    data: [],
    status: null,
  },
  openModalResolution: false,
  openModalMeasureFile: false,
  editHealthData: null,
  newPatient: null,
  addPatient: null,
  updatePatient: null,
  rulesCreatedState: null,
  rulesDeletedState: null,
  ruleSelected: null,
  openRuleSelected: null,
  tabSelected: 0,
  userCreatedId: null,
  openModalNotificationShow: false,
  openModalNotificationSend: false,
  openModalNotificationEdit: false,
  openNoteModal: false,
  historicServiceStateSelected: null,
  openAgendaModal: false,
  putLinkDeviceUser: { status: null },
  putUnlinkDeviceUser: { status: null },
  historicDevices: {
    data: [],
    status: null,
    pagination: {
      page: 0,
      total: 0,
    },
  },
  putServicesState: {
    data: null,
    status: null
  },
  postServicesState: {
    data: null,
    status: null
  },
  serviceState: { id: '', code: '' },
  serviceStateReason: { id: '', code: '' },
  serviceStateOption: { serviceState: { id: '', code: '' }, serviceStateReasons: [] },
  listServicesOptionsState: { data: [], status: null },
  listServicesTypeOptions: { data: [], status: null },
  serviceExpiration: { data: null, status: null },
};
